//
import ProductModel from '@/models/Warehouse/WhProduct'

//
export default async data => {

    //
    try {

        //
        const product_name  = data.name
            , family_id     = data.wh_family_id
            , subfamily_id  = data.wh_subfamily_id
            , response      = await ProductModel.params({ product_name, family_id, subfamily_id }).find( 'suggest_internal_code' )

        //
        return response
    } catch ( error ) {

        //
        return error.response.data
    }
}